import React, { useEffect, useContext, useState } from 'react';
import { StateContext } from '../../StateContainer';
import Editor from '@monaco-editor/react';
import 'draft-js/dist/Draft.css'; // Importa il CSS per la corretta visualizzazione
import { useParams } from 'react-router-dom';
import 'moment/locale/it';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactFlow, Background, MarkerType } from '@xyflow/react';
import 'react-json-view-lite/dist/index.css';

const ModalJsonEditor = ({
  versioniAgenteConversazionale,
  setVersioniAgenteConversazionale,
  setDettagliNodi,
  nodes,
  dettagliNodi,
  currentConversationalVersion,
  setCurrentConversationalVersion,
  setNodes,
  setEdges,
}) => {
  const {
    setDominioDelSito,
    setLoading,
    aggiornamentoDatiProgetto,
    setError,
    token,
  } = useContext(StateContext);

  const { id } = useParams();
  const [conversationalJson, setConversationalJson] = useState('');
  const [aggiornatoNodiConversazione, setAggiornatoNodiConversazione] =
    useState(false);
  const [erroreNodiConversazione, setErroreNodiConversazione] = useState(false);

  // Inizializza jsonVersionArray basandosi su dettagliNodi (se valorizzato)
  const [jsonVersionArray, setJsonVersionArray] = useState(
    dettagliNodi ? [dettagliNodi] : []
  );

  // Sincronizza jsonVersionArray quando dettagliNodi cambia
  useEffect(() => {
    setJsonVersionArray(dettagliNodi ? [dettagliNodi] : []);
  }, [dettagliNodi]);

  const closeModalCreateButton = document.getElementById(
    'modalEditorJsonButton'
  );

  const AggiornaNodiConversazione = () => {
    // Aggiorna lo stato dettagliNodi con il primo elemento dell'array (o un oggetto vuoto se l'array è vuoto)
    setDettagliNodi(jsonVersionArray[0] || {});
    if (closeModalCreateButton) {
      closeModalCreateButton.click();
    }
    toast.success('La chat è stata modificata con successo');
  };

  useEffect(() => {
    setDominioDelSito('');
    setLoading(true);

    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/project/detail`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        projectCode: id,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('tokenExpiration');
          window.location.replace('/login');
        } else {
          setLoading(false);
          setEditorValue(response.data.response.conversationalJSON);
          try {
            const parsedJson = JSON.parse(
              response.data.response.conversationalJSON
            );
            setConversationalJson(parsedJson);
          } catch (e) {
            console.warn('Invalid JSON:', e.message);
          }
          setError('');
        }
      })
      .catch((err) => setError(err));
  }, []);

  // Stato per l'editor
  const [editorValue, setEditorValue] = useState(
    JSON.stringify(conversationalJson, null, 2)
  );

  // Aggiorna editorValue quando conversationalJson cambia
  useEffect(() => {
    setEditorValue(JSON.stringify(conversationalJson, null, 2));
  }, [conversationalJson]);

  // Gestore per le modifiche nell'editor
  const handleEditorChange = (value) => {
    setEditorValue(value);
    try {
      const parsedJson = JSON.parse(value);
      setConversationalJson(parsedJson);
    } catch (e) {
      console.warn('Invalid JSON:', e.message);
    }
  };

  return (
    <div className="modal fade overlay" id="modalJsonEditor">
      <div className="modal-dialog modal-dialog-centered d-grid justify-content-center">
        <div className="modal-content" style={{ width: '1000px' }}>
          <div className="modal-header">
            <h5 className="modal-title">Versione JSON</h5>
          </div>
          <div className="modal-body">
            <div
              style={{
                border: '1px solid #ccc',
                minHeight: '200px',
                width: '100%',
              }}
            >
              <Editor
                height="50vh"
                maxHeight="50vh"
                theme="vs-dark"
                value={JSON.stringify(jsonVersionArray, null, 2)} // Formatta JSON
                onChange={(valore) => {
                  try {
                    setJsonVersionArray(JSON.parse(valore));
                  } catch (error) {
                    console.error('JSON non valido:', error);
                  }
                }}
                defaultLanguage="json"
                options={{
                  minimap: { enabled: false },
                  formatOnPaste: true,
                  formatOnType: true,
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={AggiornaNodiConversazione}
            >
              Aggiorna
            </button>
            <button
              id="modalEditorJsonButton"
              type="button"
              className="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalJsonEditor;
